import React from "react";
import {
  Table,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableRow,
  TableBody,
  Button,
  Icon,
} from "semantic-ui-react";
import ComplianceModal from "../modals/ComplianceModal";
import { getSelectedModuleData } from "@actions/compliance";
import { camelCaseToText } from "../../helpers";

const ComplianceButtons = (props) => {
  return (
    <div className="mt-1">
      <div className="flex-row gap-1 justify-end">
        <Button
          color="green"
          onClick={props.handleNew}
          disabled={props.loading || !props.type || !props.canAdd}
          icon="save"
        >
          New
        </Button>
        <Button
          color="green"
          onClick={props.handleEdit}
          disabled={props.loading || !props.selectedRowData}
          icon="save"
        >
          Edit
        </Button>
        <Button
          color="red"
          onClick={props.handleDelete}
          disabled={props.loading || !props.selectedRowData || !props.canDelete}
          icon="delete"
        >
          Delete
        </Button>
      </div>
    </div>
  );
};

class ComplianceTable extends React.Component {
  state = {
    activeIndex: null,
    selectedRowData: null,
    showModal: false,
  };

  getFields = (data) => {
    const keys = Object.keys(data).filter((key) => {
      const value = data[key];
      return (
        (typeof value !== "object" &&
          key !== "rowVersion" &&
          key !== "id" &&
          key !== "lastUpdated") ||
        value === null
      );
    });

    return keys;
  };

  handleNew = () => {
    this.setState({ selectedRowData: null }, () =>
      this.setState({ showModal: true }),
    );
  };

  handleDelete = () => {
    this.props.onDelete(this.state.selectedRowData.id);
  };

  handleEdit = async () => {
    const data = await getSelectedModuleData(
      this.props.type,
      this.state.selectedRowData.id,
    );
    this.setState({ selectedRowData: data, showModal: true });
  };

  handleSelect = (data) => () => {
    this.setState({ selectedRowData: data });
  };

  onClose = () => {
    this.setState({ showModal: false, selectedRowData: null });
  };

  onSave = async (data) => {
    await this.props.onSave(data);
  };

  mapFieldNames = (field) => {
    switch (field) {
      case "isDisabled":
        return "Hide";
      case "ordinal":
        return "Order";

      default:
        return field;
    }
  };
  isRadioField = (_field, value) => {
    return typeof value === "boolean";
  };

  render() {
    return (
      <>
        <ComplianceButtons
          {...this.state}
          {...this.props}
          handleNew={this.handleNew}
          handleDelete={this.handleDelete}
          handleEdit={this.handleEdit}
        />
        <Table singleLine>
          <TableHeader>
            <TableRow>
              {this.getFields(this.props.data[0] || this.props.model).map(
                (field, index) => (
                  <TableHeaderCell
                    textAlign={index === 0 ? "left" : "center"}
                    className="capitalize-first-letter"
                    key={field}
                  >
                    {camelCaseToText(this.mapFieldNames(field))}
                  </TableHeaderCell>
                ),
              )}
            </TableRow>
          </TableHeader>
          <TableBody>
            {this.props.data.map((data) => (
              <TableRow
                key={data.id}
                className="clickable"
                onClick={this.handleSelect(data)}
                active={this.state.selectedRowData?.id === data.id}
              >
                {this.getFields(this.props.data[0] || this.props.model).map(
                  (field, index) => {
                    // Get the value for this field
                    let value = data[field];

                    // Check if value is an object (and not null)
                    if (
                      value &&
                      typeof value === "object" &&
                      !Array.isArray(value)
                    ) {
                      // Extract the name property from nested objects
                      value = value.name ?? "-";
                    }

                    if (field == "incidentTypeId") {
                      value = this.props.incidentTypes.find(x => x.id == value)?.name
                    }

                    if (field == "eventTypeId") {
                      value = this.props.eventTypes.find(x => x.id == value)?.name
                    }

                    return (
                      <TableCell
                        key={`cell-${index}`}
                        textAlign={index === 0 ? "left" : "center"}
                      >
                        {this.isRadioField(field, value) ? (
                          <Icon
                            name={value ? "check" : "close"}
                            color={value ? "green" : "red"}
                          />
                        ) : (
                          value ?? "-"
                        )}
                      </TableCell>
                    );
                  },
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <ComplianceModal
          title={
            !this.state.selectedRowData
              ? `Create New ${this.props.type}`
              : `Edit ${this.props.type}`
          }
          open={this.state.showModal}
          type={this.props.type}
          data={this.state.selectedRowData}
          model={this.props.model}
          eventTypes={this.props.eventTypes}
          incidentTypes={this.props.incidentTypes}
          onClose={this.onClose}
          onSave={this.onSave}
        />
      </>
    );
  }
}

export default ComplianceTable;
